/**
 * field_definitions.field_code 와 동일한 키를 사용합니다.
 * API에 정의가 없을 때 getFieldLabel 두 번째 인자로 사용됩니다.
 */
export const FIELD_LABEL_DEFAULTS = {
  // basic
  contract_date: '계약일',
  type: '계약구분',
  cancellation_date: '해약일자',
  relocation_date: '이장일자',
  memo: '메모',
  custom_field_1: '커스텀 필드 1',
  custom_field_2: '커스텀 필드 2',
  custom_field_3: '커스텀 필드 3',
  custom_field_4: '커스텀 필드 4',
  custom_field_5: '커스텀 필드 5',

  // mausoleum
  member_number: '묘적번호',
  complex: '단지',
  area: '묘역',
  row_number: '열',
  number: '번호',
  tomb_type: '묘지형태',
  number_of_tombs: '기수',
  tomb_shape: '형태',
  area_size: '크기 (평)',
  period: '계약기간',
  mausoleum_etc: '기타',
  mausoleum_location: '묘역위치',
  management_period: '관리일',
  payment_status: '납부여부',

  // dead
  dead_name: '사망자명',
  gender: '성별',
  dead_resident_number: '주민등록번호',
  burial_method_1: '장례구분1',
  burial_method_2: '장례구분2',
  death_date: '사망일',
  death_place: '사망장소',
  death_cause: '사망원인',
  burial_date: '설묘일',
  dead_address: '주소',
  dead_address_detail: '상세주소',

  // acquaintance
  acquaintance_name: '연고자명',
  relationship: '관계',
  phone: '연락처',
  acquaintance_resident_number: '주민등록번호',
  acquaintance_address: '주소',
  acquaintance_address_detail: '상세주소',
  is_primary_contact: '주 연락처로 설정',
  registration_date: '등록일자',

  // cost
  usage_fee: '사용료',
  management_fee: '관리비',
  burial_work_fee: '매장작업비',
  installation_fee: '설치비',
  repair_fee: '보수비',
  removal_work_fee: '이장공사비',
  other_work_fee: '기타공사비',
  stone_processing_fee: '비석가공비',
  agency_fee: '대행료',
  reuse_fee: '재사용료',
  total_cost: '총 비용',
  cost_memo: '비용 관련 메모',

  // document (document_type 값과 동일)
  death_certificate: '사망진단서',
  burial_certificate: '매장신고서',
  family_relation_certificate: '가족관계증명서',
  family_register: '제적등본',
  cremation_certificate: '화장증명서',
  privacy_consent: '개인정보동의서',
  epitaph: '비문',
  other: '기타',

  // stone
  stone_name: '석물 종류',
  stone_cost: '비용',
  stone_memo: '메모',

  // engraving
  engraving_type: '각자 종류',
  engraving_fee: '금액',
  content_file: '내용 파일',
  engraving_memo: '메모',

  // maintenance
  maintenance_content: '보수 내용',
  maintenance_cost: '보수 비용',
  maintenance_memo: '메모'
};
